import React from "react"
import { cn } from "../../utils/cn"

export const Card = React.forwardRef(({ className, ...props }, ref) => (
  <div ref={ref} data-slot="card" className={cn("bg-card text-card-foreground flex flex-col gap-4 rounded-xl border border-border py-5", className)} {...props} />
))
Card.displayName = "Card"

export const CardHeader = React.forwardRef(({ className, ...props }, ref) => (
  <div ref={ref} data-slot="card-header" className={cn("flex flex-col gap-1.5 px-5", className)} {...props} />
))
CardHeader.displayName = "CardHeader"

export const CardTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h3 ref={ref} data-slot="card-title" className={cn("text-sm font-semibold text-foreground leading-none", className)} {...props} />
))
CardTitle.displayName = "CardTitle"

export const CardDescription = React.forwardRef(({ className, ...props }, ref) => (
  <p ref={ref} data-slot="card-description" className={cn("text-xs text-muted-foreground", className)} {...props} />
))
CardDescription.displayName = "CardDescription"

export const CardAction = React.forwardRef(({ className, ...props }, ref) => (
  <div ref={ref} data-slot="card-action" className={cn("ml-auto", className)} {...props} />
))
CardAction.displayName = "CardAction"

export const CardContent = React.forwardRef(({ className, ...props }, ref) => (
  <div ref={ref} data-slot="card-content" className={cn("px-5", className)} {...props} />
))
CardContent.displayName = "CardContent"

export const CardFooter = React.forwardRef(({ className, ...props }, ref) => (
  <div ref={ref} data-slot="card-footer" className={cn("flex items-center px-5", className)} {...props} />
))
CardFooter.displayName = "CardFooter"